import axios from 'axios';

import { getEnv, getCsrfToken } from '@ctct/ctct-helpers';

const getBaseUrl = () => {
  if (getEnv() === 'local') {
    return 'https://localhost:9000/v1/settings';
  }

  return `https://app${getEnv()}constantcontact.com/v1/settings`;
};

const options = { credentials: 'include', headers: {} };
const token = getCsrfToken();

if (getEnv() !== 'local') {
  options.headers['X-CSRF-Token'] = token;
}

const getFeatureSetting = async (applicationId, settingName) =>
  (await axios.get(`${getBaseUrl()}/applications/${applicationId}/accounts/features/${settingName}`, options)).data;

export default {
  getFeatureSetting,
};
